/**
 * API клієнт для ref.customer_cards (Порція Роздріб.2/5a).
 * Backend: /api/v1/retail/customer-cards. Permissions: retail.customer_card.manage.
 * Окремий шлях lookup — для POS UI (Порція 6).
 */
import { api } from './client';
import type { Page } from './catalogs';

export type CustomerCardStatus = 'active' | 'blocked' | 'lost' | 'expired';

export interface CustomerCard {
  id: string;
  organization_id: string;
  card_code: string;
  customer_contractor_id: string | null;
  holder_name: string | null;
  holder_phone: string | null;
  holder_email: string | null;
  holder_birthdate: string | null;
  bonus_balance: string;
  status: CustomerCardStatus;
  issued_at: string;
  expires_at: string | null;
  deletion_mark: boolean;
  created_at: string;
  created_by: string | null;
  comment: string | null;
}

export interface CustomerCardCreate {
  organization_id: string;
  card_code: string;
  customer_contractor_id?: string | null;
  holder_name?: string | null;
  holder_phone?: string | null;
  holder_email?: string | null;
  holder_birthdate?: string | null;
  bonus_balance?: string;
  status?: CustomerCardStatus;
  expires_at?: string | null;
  comment?: string | null;
}

export type CustomerCardUpdate = Partial<Omit<CustomerCardCreate, 'organization_id' | 'bonus_balance'>>;

export interface CustomerCardLookup {
  id: string;
  organization_id: string;
  card_code: string;
  holder_name: string | null;
  holder_phone: string | null;
  bonus_balance: string;
  status: CustomerCardStatus;
}

export const retailCustomerCards = {
  list: (params?: {
    organization_id?: string;
    status?: CustomerCardStatus;
    customer_contractor_id?: string;
    limit?: number;
    offset?: number;
  }) =>
    api.get<Page<CustomerCard>>('/retail/customer-cards', { params }).then((r) => r.data),
  get: (id: string) => api.get<CustomerCard>(`/retail/customer-cards/${id}`).then((r) => r.data),
  lookup: (params: { organization_id: string; card_code: string }) =>
    api.get<CustomerCardLookup>('/retail/customer-cards/lookup', { params }).then((r) => r.data),
  create: (payload: CustomerCardCreate) =>
    api.post<CustomerCard>('/retail/customer-cards', payload).then((r) => r.data),
  update: (id: string, payload: CustomerCardUpdate) =>
    api.patch<CustomerCard>(`/retail/customer-cards/${id}`, payload).then((r) => r.data),
  remove: (id: string) => api.delete(`/retail/customer-cards/${id}`).then(() => undefined),
};
